module.exports = __webpack_public_path__ + "static/img/图标_fb.7eaf0249.svg";